import { render } from "./return.vue?vue&type=template&id=2a5ef2f6"
import script from "./return.vue?vue&type=script&lang=js"
export * from "./return.vue?vue&type=script&lang=js"

import "./return.vue?vue&type=style&index=0&id=2a5ef2f6&lang=scss"

import exportComponent from "D:\\JYC\\产品源码\\前端\\工作流引擎\\stgd.oa.mobile.h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__